import React from 'react';
import { Box } from '@material-ui/core';
import SubPageSelectButton from './SubPageSelectButton';

export interface SubPageSelectAction {
    text: string;
    notificationCount?: number;
}

interface SubPageSelectProps {
    actions: SubPageSelectAction[];
    selectedIndex: number;
    onSelect: (index: number) => void;
}

const SubPageSelect = ({ actions, selectedIndex, onSelect }: SubPageSelectProps) => (
    <Box display='flex'>
        {actions.map(({ text, notificationCount }, index) => (
            <div key={text}>
                <Box ml={1} />
                <SubPageSelectButton
                    text={text}
                    active={index === selectedIndex}
                    notificationCount={notificationCount}
                    onClick={() => onSelect(index)}
                />
            </div>
        ))}
    </Box>
);

export default SubPageSelect;
